module.exports = __webpack_public_path__ + "static/assets/82454fb4d6076db78d9766d540d22ef6.svg";